const getUserIPAddress = async () => {
	try {
		const res = await fetch("https://api.ipify.org?format=json");
		const data = await res.json();

		return data.ip;
	} catch (error: any) {
		throw new Error(error);
	}
};

export default getUserIPAddress;
